<template>
  <section class='common-redio' @click='handClick'>
    <svg-icon v-if='value' class-name="icon-16" icon-class="radio-checked"></svg-icon>
    <svg-icon v-else class-name="icon-16" icon-class="radio-uncheck"></svg-icon>
  </section>
</template>

<script>
export default {
  name: 'c-redio',
  props: {
    value: { default: false, type: Boolean },
    name: { default: '', type: String },
    // className: { default:  }
  },
  methods: {
    handClick() {
      this.$emit('click', this.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.common-redio {
  display: inline-block;
  margin-right: 8px;
  cursor: pointer;
}
</style>
